import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { MENU_ITEMS } from "../config/menuConfig";


export default function TenantRoute({ menuId, children }) {
  const { user, userProfile, tenantConfig, loading } = useAuth();

  if (loading) return <div style={{ padding: 16 }}>Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;

  const enabled = tenantConfig?.enabledMenus ?? [];
  if (!enabled.includes(menuId)) return <Navigate to="/unauthorized" replace />;

  const role = userProfile?.role ?? "member";
  const menu = MENU_ITEMS.find((m) => m.id === menuId);

  // If the menuId is unknown, fail safe
  if (!menu) return <Navigate to="/unauthorized" replace />;

  // Role check
  if (!menu.roles.includes(role)) return <Navigate to="/unauthorized" replace />;

  return children;
}
